export default __webpack_public_path__ + "static/media/handshake_filled.137a2c75.svg";